import React, { ReactElement } from "react";
import { connect, FormikContextType } from "formik";
import { AutorisatieNiveauState } from "../infra";
import AutorisatieNiveauGrid from "../infra/autorisatie-niveau-grid";

const Voorkeuren = ({ formik: { values } }: { formik: FormikContextType<AutorisatieNiveauState> }): ReactElement => {
  return <AutorisatieNiveauGrid options={Object.keys(values.voorkeuren)} formikKey={"voorkeuren"} />;
};

export default connect<{}, AutorisatieNiveauState>(Voorkeuren);
